import { DocumentType } from '../VerificationProcess';
export const VietnamVerificationConfig = {
    country: 'VN',
    name: 'Vietnam',
    estimatedDuration: 14, // 14 business days
    requiredDocuments: [
        DocumentType.business_license,
        DocumentType.tax_certificate,
        DocumentType.identity_card,
        DocumentType.bank_statement,
        DocumentType.address_proof,
    ],
    steps: [
        {
            id: 'business_registration',
            name: 'Business Registration Verification',
            description: 'Verify business registration with Vietnamese authorities',
            required: true,
            order: 1,
            documentTypes: [DocumentType.business_license, DocumentType.tax_certificate],
            validationRules: {
                businessLicense: {
                    required: true,
                    validFor: 'Vietnam',
                    issuedBy: ['Ministry of Planning and Investment', 'Department of Planning and Investment'],
                },
                taxCertificate: {
                    required: true,
                    validFor: 'Vietnam',
                    issuedBy: ['General Department of Taxation'],
                },
            },
            metadata: {
                authority: 'Ministry of Planning and Investment',
                contactInfo: {
                    website: 'https://dangkykinhdoanh.gov.vn',
                    phone: '+84-24-3845-5128',
                },
            },
        },
        {
            id: 'identity_verification',
            name: 'Identity Verification',
            description: 'Verify identity of organization representatives',
            required: true,
            order: 2,
            documentTypes: [DocumentType.identity_card, DocumentType.passport],
            validationRules: {
                identityCard: {
                    required: true,
                    validFor: 'Vietnam',
                    issuedBy: ['Ministry of Public Security'],
                },
                passport: {
                    required: false,
                    validFor: 'Vietnam',
                    issuedBy: ['Ministry of Public Security'],
                },
            },
            metadata: {
                authority: 'Ministry of Public Security',
                contactInfo: {
                    website: 'https://hochieu.congdancu.vn',
                    phone: '+84-24-3824-0000',
                },
            },
        },
        {
            id: 'financial_verification',
            name: 'Financial Verification',
            description: 'Verify financial standing and banking information',
            required: true,
            order: 3,
            documentTypes: [DocumentType.bank_statement],
            validationRules: {
                bankStatement: {
                    required: true,
                    validFor: 'Vietnam',
                    minimumBalance: 100000000, // 100 million VND
                    issuedBy: ['State Bank of Vietnam', 'Commercial Banks'],
                },
            },
            metadata: {
                authority: 'State Bank of Vietnam',
                contactInfo: {
                    website: 'https://sbv.gov.vn',
                    phone: '+84-24-3936-0000',
                },
            },
        },
        {
            id: 'address_verification',
            name: 'Address Verification',
            description: 'Verify business address and location',
            required: true,
            order: 4,
            documentTypes: [DocumentType.address_proof],
            validationRules: {
                addressProof: {
                    required: true,
                    validFor: 'Vietnam',
                    issuedBy: ['People\'s Committee', 'Department of Natural Resources and Environment'],
                },
            },
            metadata: {
                authority: 'People\'s Committee',
                contactInfo: {
                    website: 'https://chinhphu.vn',
                    phone: '+84-24-0804-3000',
                },
            },
        },
        {
            id: 'compliance_check',
            name: 'Compliance Check',
            description: 'Final compliance and regulatory check',
            required: true,
            order: 5,
            documentTypes: [],
            validationRules: {
                compliance: {
                    required: true,
                    checks: ['tax_compliance', 'labor_compliance', 'environmental_compliance'],
                },
            },
            metadata: {
                authority: 'Ministry of Planning and Investment',
                contactInfo: {
                    website: 'https://mpi.gov.vn',
                    phone: '+84-24-3845-5128',
                },
            },
        },
    ],
    metadata: {
        currency: 'VND',
        language: 'vi',
        timezone: 'Asia/Ho_Chi_Minh',
        businessHours: {
            start: '08:00',
            end: '17:00',
            timezone: 'Asia/Ho_Chi_Minh',
        },
        holidays: [
            '2024-01-01', // New Year
            '2024-02-10', // Tet Holiday
            '2024-02-11', // Tet Holiday
            '2024-02-12', // Tet Holiday
            '2024-02-13', // Tet Holiday
            '2024-02-14', // Tet Holiday
            '2024-04-18', // Hung Kings Day
            '2024-04-30', // Liberation Day
            '2024-05-01', // Labor Day
            '2024-09-02', // National Day
        ],
    },
};
//# sourceMappingURL=data:application/json;base64,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